import { API_URL } from '../../../request'

export const addListingUrl = () => {
  return API_URL + `/add/webListing`
}
export const listPropertyUrl = () => {
  return API_URL + `/propertyList/list`
}
export const updateListingUrl = () => {
  return API_URL + `/webListing/update`
}
export const deleteFileUrl = () => {
  return API_URL + `/delete/file`
}
export const deleteListingUrl = (id) => {
  return API_URL + `/webListing/${id}`
}
export const updateOrderProppertyUrl = (id) => {
  return API_URL + `/property/updateMany`
}
export const propertyLocationOptionsUrl  = () => {
  return API_URL + `/propertyLocationOptions`
}
